import { Languages, Globe, Building2, Palette } from "lucide-react";

const items = [
  { icon: Languages, t: "English & Arabic", d: "Full RTL/LTR interface for teams across MENA and beyond." },
  { icon: Globe, t: "Multi-tenant SaaS", d: "Isolated data per company, subdomain, and branch." },
  { icon: Building2, t: "Multi-branch ready", d: "Branch-level policies, holidays, and reporting out of the box." },
  { icon: Palette, t: "Your branding", d: "Custom themes, logos, and dashboards per tenant." },
];

export default function LocalizationStrip() {
  return (
    <section className="py-16 bg-white border-y border-slate-200" data-testid="localization-strip">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-6">
          {items.map((i, idx) => {
            const I = i.icon;
            return (
              <div key={idx} className="flex items-start gap-3">
                <div className="h-10 w-10 rounded-xl bg-[#E6F6EC] flex items-center justify-center shrink-0">
                  <I className="h-5 w-5 text-[#00A651]" />
                </div>
                <div>
                  <div className="font-extrabold text-[#1F1E4E] text-sm">{i.t}</div>
                  <div className="text-xs text-slate-500 mt-1 leading-relaxed">{i.d}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
